import { render, staticRenderFns } from "./LandingpageCardContent.vue?vue&type=template&id=7c063b58&"
import script from "./LandingpageCardContent.vue?vue&type=script&lang=js&"
export * from "./LandingpageCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports